import React, { useState } from 'react';
import { ModalWrapper } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { MultiMailSendForm } from 'components/atoms';

export interface MultiMailSendModalProps extends PopupProps {
    ids: string;
    group: string;
    toStudents: string;   
    toCrms: string;   
    mail_type: string;
}

const B2cMultiMailSendModal = ({ isOpen, onClose, ids, group,toStudents, toCrms, mail_type }: MultiMailSendModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

  /* ======================================================
  * hooks
  * ====================================================== */

   /* ======================================================
   * variables
   * ====================================================== */

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onConfirm = () => {
        onClose?.(true);
    };
    
    /* ======================================================
    * methods
    * ====================================================== */
 
       
  /* ======================================================
   * effects
   * ====================================================== */

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={1000} title={mail_type==='type13'?group==='seminar'?'확인서발급':'수료증발송':'메일 발송'} closable>
            <MultiMailSendForm 
                ids={ids}
                mail_group={group}
                toStudents={toStudents}
                toCrms={toCrms}
                mail_type={mail_type}
                onCancel={onCancel}
                onConfirm={onConfirm}
            />
        </ModalWrapper>  
    )    
};

export default React.memo(B2cMultiMailSendModal);    